import React from "react";
import CartItems from "../components/caartitems/CartItems";
import Seo from "../components/seo/Seo";

const Cart = ()=> {
    return (
        <div>
            <Seo title="Your Cart" path="/cart" noindex />
            <CartItems/>
        </div>
    )
}

export default Cart;